import { IRouteErrorResponse } from '@/interfaces/IRouteErrorResponse';

export function isRouteErrorResponse(body: unknown): body is IRouteErrorResponse {
  return (body as IRouteErrorResponse).isRouteErrorResponse;
}
